import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const GoBackRedirect = ({ path }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (path) {
            navigate(path);
        } else {
            navigate(-1);
        }
    }, [navigate, path]);

    return null;
};

export default GoBackRedirect;
